import type { Language } from "@/i18n/types";

export function formatDate(iso: string, lang: Language): string {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(lang === "sv" ? "sv-SE" : "en-GB", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}

export function casinoReviewPath(prefix: string, lang: Language, slug: string) {
  return `${prefix}/${lang === "sv" ? "recensioner" : "reviews"}/${slug}`;
}

export function paymentPath(prefix: string, lang: Language, slug: string) {
  return `${prefix}/${lang === "sv" ? "betalningsmetoder" : "payment-methods"}/${slug}`;
}

export function guidePath(prefix: string, lang: Language, slug: string) {
  return `${prefix}/${lang === "sv" ? "guider" : "guides"}/${slug}`;
}

export function slotPath(prefix: string, lang: Language, slug: string) {
  return `${prefix}/${lang === "sv" ? "spelautomater" : "slots"}/${slug}`;
}

export function providerPath(prefix: string, lang: Language, slug: string) {
  return `${prefix}/${lang === "sv" ? "speltillverkare" : "software-providers"}/${slug}`;
}
